import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Modal,
  Button,
} from "reactstrap";

import { Link } from "react-router-dom";
import OrderProduct from "./OrderProduct";
import moment from "moment";
import { orderStatus } from "../../Components/constants/layout";
import SalesChannels from "../../Components/Common/SalesChannels";
import RestrictedChannels from "../../Components/Common/RestrictedChannels";
import { Typography } from "@mui/material";

const SupplierOrderDetail = ({
  show,
  onSendClick,
  onCloseClick,
  onShipToWarehouseClick,
  onCancelClick,
  onSetMOQClick,
  onSetMOVClick,
  orders,
}) => {
  const [updateMo, setUpdateMo] = useState(false);
  const getStatus = (order) => {
    if (Number(orders?.suoStatus) == orderStatus.STATUS_ACTIVE) {
      switch (orders?.statusText) {
        case "MOQ Met":
          return (
            <span className="badge text-uppercase text-dark bg-success">
              {" "}
              {orders?.statusText}{" "}
            </span>
          );
        case "Waiting for MOQ":
          return (
            <span className="badge text-uppercase text-dark bg-warning">
              {" "}
              {orders?.statusText}{" "}
            </span>
          );
        case "Waiting for MOV":
          return (
            <span className="badge text-uppercase text-dark bg-warning">
              {" "}
              {orders?.statusText}{" "}
            </span>
          );
        case "Cancelled":
          return (
            <span className="badge text-uppercase text-dark bg-danger">
              {" "}
              {orders?.statusText}{" "}
            </span>
          );
        case "MOV Met":
          return (
            <span className="badge text-uppercase text-dark bg-success">
              {" "}
              {orders?.statusText}{" "}
            </span>
          );
        default:
          return <span></span>;
      }
    } else {
      switch (orders?.suoStatus) {
        case orderStatus.STATUS_ORDERED:
          return (
            <span className="badge text-uppercase text-dark bg-success">
              ordered
            </span>
          );
        case orderStatus.STATUS_CANCELLED:
          return (
            <span className="badge text-uppercase text-dark bg-danger">
              cancelled
            </span>
          );
        case orderStatus.STATUS_EXPIRED:
          return (
            <span className="badge text-uppercase text-dark bg-warning">
              {" "}
              EXPIRED
            </span>
          );
        case orderStatus.STATUS_MOQ_MET:
          return (
            <span className="badge text-uppercase text-dark bg-success">
              MOQ Met
            </span>
          );
        case orderStatus.STATUS_MOV_MET:
          return (
            <span className="badge text-uppercase text-dark bg-success">
              MOV Met
            </span>
          );
        default:
          return <span></span>;
      }
    }
  };

  const getCancellationReason = () => {
    console.log("Cancellation reason:", orders?.suoCancellationReason);
    switch (orders?.suoCancellationReason) {
      case 0:
        return "The item is out of stock.";
      case 1:
        return "The item is incorrect.";
      case 2:
        return "The order was canceled at the customer's request.";
      case 3:
        return "The order was canceled due to insufficient quantity.";
      case 4:
        return "The price of the item has changed.";
      case 5:
        return "The order was canceled for another reason.";
      case 11:
        return "The MOQ (Minimum Order Quantity) was not met.";
      case 12:
        return "The MOV (Minimum Order Value) was not met.";
      default:
        return "No specific reason provided.";
    }
  };

  const calculateTotalPrice = () => {
    return orders?.orders.reduce(
      (sum, order) => sum + (order.ordTotalPrice || 0),
      0
    );
  };

  const calculateTotalCost = () => {
    return orders?.orders.reduce(
      (sum, order) => sum + (order.ordTotalCost || 0),
      0
    );
  };

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="xl">
      <div className="modal-header">
        <h5 className="modal-title mt-0">Order Details</h5>
        <button
          onClick={onCloseClick}
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <Container fluid>
          <Row>
            <Col>
              <div className="d-sm-flex align-items-center mb-2">
                {orders?.suoStatus != 5 && orders?.suoStatus != 7 && (
                  <div className="flex-shrink-0 mt-2 mt-sm-0 ms-1">
                    <Link
                      to="#"
                      onClick={() => onCancelClick(orders)}
                      className="btn btn-soft-danger btn-sm mt-2 mt-sm-0"
                    >
                      <i className="mdi mdi-archive-remove-outline align-middle me-1"></i>{" "}
                      Cancel Order
                    </Link>
                  </div>
                )}
                {(orders?.statusText === "MOQ Met" ||
                  orders?.statusText === "MOV Met" ||
                  orders?.suoStatus == 20 ||
                  orders?.suoStatus == 21) &&
                  orders?.suoStatus != 5 &&
                  orders?.suoStatus != 7 && (
                    <div className="flex-shrink-0 mt-2 mt-sm-0 ms-1">
                      <Link
                        to="#"
                        className="btn btn-soft-success btn-sm mt-2 mt-sm-0"
                        onClick={() => onSendClick(orders)}
                      >
                        <i className="ri-send-plane-fill align-middle me-1"></i>{" "}
                        Place Order
                      </Link>
                    </div>
                  )}
                {orders?.statusText === "" &&
                  orders?.suoStatus != 5 &&
                  orders?.suoStatus != 7 &&
                  orders?.suoStatus != orderStatus.STATUS_MOQ_MET &&
                  orders?.suoStatus != orderStatus.STATUS_MOV_MET && (
                    <div className="flex-shrink-0 mt-2 mt-sm-0 ms-1">
                      <Link
                        to="#"
                        className="btn btn-soft-success btn-sm mt-2 mt-sm-0"
                        onClick={() => onShipToWarehouseClick(orders)}
                      >
                        <i className="ri-truck-fill align-middle me-1"></i> Ship
                        to warehouse
                      </Link>
                    </div>
                  )}
              </div>
              <Card>
                <CardHeader>
                  <div className="d-sm-flex align-items-center">
                    <h5 className="card-title flex-grow-1 mb-0">
                      Product Detail
                    </h5>
                  </div>
                </CardHeader>
                <CardBody>
                  <div className="flex-grow-1 ms-3">
                    <Row>
                      <h5>
                        <a href={orders?.productURL} target="_blank">
                          <b>{orders?.productName}</b>
                        </a>
                      </h5>
                    </Row>
                    <Row>
                      <div>
                        <span>
                          <b>UPC:</b> {orders?.productUPC || "N/A"}
                          {orders?.productASIN && (
                            <span> / <b>ASIN:</b> {orders.productASIN}</span>
                          )}
                          {orders?.productSKU && (
                            <span> / <b>SKU:</b> {orders.productSKU}</span>
                          )}
                        </span>
                      </div>
                    </Row>
                    <Row>
                      <div>
                        <b>Supplier :</b>
                        {orders?.supplierName}{" "}
                      </div>
                    </Row>
                    <Row>
                      <div>
                        <b>Supplier code :</b>
                        {orders?.supplierCode}{" "}
                      </div>
                    </Row>
                    <Row>
                      <div>
                        <b>Date :</b>
                        {moment(orders?.suoDateCreated).format(
                          "MM/DD/YYYY, h:mm a"
                        )}
                      </div>
                    </Row>
                    {orders?.ord_datePurchaseOrder && (
                      <Row>
                        <div>
                          <b>Purchased Date: </b>
                          {moment(orders?.ord_datePurchaseOrder).format(
                            "MM-DD-Y, h:mm a"
                          )}
                        </div>
                      </Row>
                    )}

                    <Row>
                      <div>
                        <b>Extended Lead Time: </b>
                        {orders?.orders[0]?.ordExtendedLeadTime
                          ? `${orders.orders[0].ordExtendedLeadTime} days`
                          : "N/A"}
                      </div>
                    </Row>
                    <Row>
                      <div>
                        <b>MAP (Minimum Advertised Price): </b>
                        {orders?.orders[0]?.ordMAP
                          ? orders.orders[0].ordMAP.toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })
                          : "N/A"}
                      </div>
                    </Row>
                    <Row className="mt-1">
                      <div>
                        <b>Sales Channel: </b>
                        <SalesChannels
                          channel={orders?.orders[0]?.ordSalesChannel}
                        />
                      </div>
                    </Row>
                    <Row className="mt-1">
                      <div>
                        <b>Restricted Channel: </b>
                        <RestrictedChannels
                          channel={orders?.orders[0]?.ordRestrictedChannel}
                        />
                      </div>
                    </Row>
                    <Row className="mt-1">
                      <div>
                        <b>Important notes:</b>
                        <Typography variant="body2" color="textSecondary">
                          {orders?.orders[0]?.ordImportantNotes}
                        </Typography>
                      </div>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center">
                    <h5 className="card-title flex-grow-1 mb-0">
                      Order #{orders?.suoId}
                    </h5>
                    <div className="flex-shrink-0">{getStatus()}</div>
                    {(orders?.statusText === "Waiting for MOQ" ||
                      orders?.statusText === "Waiting for MOV") && (
                      <div className="flex-shrink-0 ms-2">
                        <Button
                          color="success"
                          size="sm"
                          className="btn text-dark btn-sm badge text-uppercase"
                          onClick={() => {
                            if (orders?.statusText === "Waiting for MOQ") {
                              onSetMOQClick(orders);
                            } else if (
                              orders?.statusText === "Waiting for MOV"
                            ) {
                              onSetMOVClick(orders);
                            }
                          }}
                        >
                          {" "}
                          Set{" "}
                          {orders?.statusText === "Waiting for MOQ"
                            ? "MOQ Met"
                            : "MOV Met"}
                        </Button>
                      </div>
                    )}
                  </div>

                  {orders?.suoCancellationReason != null && (
                    <div className="mt-2">
                      <p className="text-muted mb-0">
                        <b>Cancellation Reason:</b> {getCancellationReason()}
                      </p>
                    </div>
                  )}
                </CardHeader>
                <CardBody>
                  <div className="table-responsive table-card">
                    <table className="table table-nowrap align-middle table-borderless mb-0">
                      <thead className="table-light text-muted">
                        <tr>
                          <th scope="col">Product Details</th>
                          <th scope="col">Status</th>

                          <th scope="col" className="text-end">
                            Item Price
                          </th>
                          <th scope="col" className="text-end">
                            Item Cost
                          </th>
                          <th scope="col" className="text-end">
                            Quantity
                          </th>
                          <th scope="col" className="text-end">
                            Total Cost
                          </th>
                          <th scope="col" className="text-end">
                            Total Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders?.orders.map((order, key) => (
                          <OrderProduct
                            order={order}
                            statusText={orders?.statusText}
                            key={key}
                            updateMo={updateMo}
                          />
                        ))}
                        <tr className="border-top border-top-dashed">
                          <td colSpan="2">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="updateMoCheckbox"
                                checked={updateMo}
                                onChange={(e) => setUpdateMo(e.target.checked)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="updateMoCheckbox"
                              >
                                Update MOQ/MOV on change quantity
                              </label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr className="border-top border-top-dashed">
                          <th scope="row"></th>
                          <th scope="row"></th>
                          <th scope="row"></th>
                          <th scope="row"></th>
                          <th scope="row">Total (USD) :</th>
                          <th className="text-end">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(calculateTotalCost())}
                          </th>
                          <th className="text-end">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(calculateTotalPrice())}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={onCloseClick}
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default SupplierOrderDetail;
